import { Collapse, Typography } from "antd";
import CommonHeader from "../../../components/ui/CommonHeader";
import WebLayout from "../../../layouts/web";
import Footer from "../../../layouts/web/_components/footer";
import Platform from "../../../layouts/web/_components/platform";
import HelpInfo from "./_components/HelpInfo";
import CloseIcon from "./_icons/CloseIcon";
import PlusIcon from "./_icons/PlusIcon";

const { Text, Paragraph } = Typography;

export default function Faq() {
  const faqData = [
    // ১. সাধারণ তথ্যাবলী
    {
      key: "1",
      category: "সাধারণ তথ্যাবলী",
      question: "ManPowerX আসলে কী?",
      answer:
        "ManPowerX হলো একটি ডিজিটাল লার্নিং প্ল্যাটফর্ম যা বিশেষভাবে বাংলাদেশের বিদেশগামী কর্মীদের জন্য তৈরি করা হয়েছে। আমরা বিভিন্ন কারিগরি দক্ষতা (যেমন: ওয়েল্ডিং, ইলেকট্রিক্যাল, কনস্ট্রাকশন), কর্মক্ষেত্রের নিরাপত্তা এবং বিদেশি ভাষার ওপর ভিডিও-ভিত্তিক ট্রেনিং দিয়ে থাকি, যাতে আপনি বিদেশে গিয়ে আরও ভালো কাজ এবং বেশি বেতন পেতে পারেন।",
    },
    {
      key: "2",
      category: "সাধারণ তথ্যাবলী",
      question: "ManPowerX ব্যবহার করতে কি কম্পিউটার প্রয়োজন?",
      answer:
        "না। ManPowerX অ্যাপটি মোবাইল ফোনের জন্য তৈরি। আপনি গুগল প্লে-স্টোর থেকে আমাদের অ্যাপটি ডাউনলোড করে আপনার স্মার্টফোনেই সম্পূর্ণ ট্রেনিং শেষ করতে পারবেন।",
    },
    {
      key: "3",
      category: "সাধারণ তথ্যাবলী",
      question: "ManPowerX কি কোনো রিক্রুটিং এজেন্সি?",
      answer: (
        <>
          না, আমরা কোনো রিক্রুটিং এজেন্সি নই। আমরা সরাসরি ভিসা দেই না বা চাকরির
          নিশ্চয়তা দেই না। তবে, আমরা আপনাকে এমন{" "}
          <strong className="text-theme-zinc-700">
            দক্ষতা এবং ভেরিফাইড সার্টিফিকেট
          </strong>{" "}
          প্রদান করি যা আপনাকে বৈধ রিক্রুটিং এজেন্সি এবং বিদেশি নিয়োগকর্তাদের
          কাছে একজন যোগ্য প্রার্থী হিসেবে তুলে ধরে।
        </>
      ),
    },

    // ২. কোর্স এবং ট্রেনিং
    {
      key: "4",
      category: "কোর্স এবং ট্রেনিং",
      question: "আমি ManPowerX-এ কোন কোন কাজ শিখতে পারব?",
      answer: (
        <>
          <div className="mb-2">
            আমরা বিভিন্ন বিষয়ের ওপর কোর্স অফার করি, যেমন:
          </div>

          <ul className="space-y-2 !list-none">
            <li className="relative pl-5 before:content-[''] before:absolute before:-left-2.5 before:top-[9px] before:w-1.5 before:h-1.5 before:bg-theme-zinc-700 before:rounded-full">
              কনস্ট্রাকশন (রাজমিস্ত্রি, টাইলস সেটিং, শাটারিং)
            </li>
            <li className="relative pl-5 before:content-[''] before:absolute before:-left-2.5 before:top-[9px] before:w-1.5 before:h-1.5 before:bg-theme-zinc-700 before:rounded-full">
              ইলেকট্রিক্যাল এবং প্লাম্বিং
            </li>
            <li className="relative pl-5 before:content-[''] before:absolute before:-left-2.5 before:top-[9px] before:w-1.5 before:h-1.5 before:bg-theme-zinc-700 before:rounded-full">
              ওয়েল্ডিং এবং পাইপফিটিং
            </li>
            <li className="relative pl-5 before:content-[''] before:absolute before:-left-2.5 before:top-[9px] before:w-1.5 before:h-1.5 before:bg-theme-zinc-700 before:rounded-full">
              ক্যাটারিং এবং হসপিটালিটি (হোটেল/রেস্টুরেন্ট কাজ)
            </li>
            <li className="relative pl-5 before:content-[''] before:absolute before:-left-2.5 before:top-[9px] before:w-1.5 before:h-1.5 before:bg-theme-zinc-700 before:rounded-full">
              ক্লিনিং এবং ফ্যাসিলিটি ম্যানেজমেন্ট
            </li>
            <li className="relative pl-5 before:content-[''] before:absolute before:-left-2.5 before:top-[9px] before:w-1.5 before:h-1.5 before:bg-theme-zinc-700 before:rounded-full">
              বিদেশি ভাষা (আরবি, ইংরেজি, কোরিয়ান ইত্যাদি)
            </li>
          </ul>
        </>
      ),
    },
    {
      key: "5",
      category: "কোর্স এবং ট্রেনিং",
      question: "একটি কোর্স শেষ করতে কতদিন সময় লাগে?",
      answer:
        "বেশিরভাগ কোর্স ২ থেকে ৪ সপ্তাহের মধ্যে শেষ করার মতো করে সাজানো হয়েছে। তবে এটি নির্ভর করবে আপনি প্রতিদিন কতটুকু সময় দিচ্ছেন তার ওপর।",
    },

    // ৩. সার্টিফিকেট এবং চাকরি
    {
      key: "6",
      category: "সার্টিফিকেট এবং চাকরি",
      question: "কোর্স শেষ করার পর আমি কি সার্টিফিকেট পাব?",
      answer: (
        <>
          হ্যাঁ। প্রতিটি কোর্সের সবগুলো ক্লাস শেষ করে ফাইনাল পরীক্ষায় পাস করলে
          আপনি একটি ডিজিটাল{" "}
          <strong className="text-theme-zinc-700">
            "ManPowerX ভেরিফাইড সার্টিফিকেট"
          </strong>{" "}
          পাবেন।
        </>
      ),
    },
    {
      key: "7",
      category: "সার্টিফিকেট এবং চাকরি",
      question:
        "একজন নিয়োগকর্তা বা মালিক কীভাবে আমার সার্টিফিকেট যাচাই করবেন?",
      answer: (
        <>
          আমাদের প্রতিটি সার্টিফিকেটে একটি ইউনিক{" "}
          <strong className="text-theme-zinc-700 font-roboto">QR Code</strong>{" "}
          থাকে। যেকোনো এজেন্সি বা নিয়োগকর্তা তাদের ফোন দিয়ে কোডটি স্ক্যান
          করলেই আমাদের পোর্টালে আপনার নাম, ছবি এবং আপনি কী কী কাজ শিখেছেন তা
          দেখতে পাবেন।
        </>
      ),
    },
    {
      key: "8",
      category: "সার্টিফিকেট এবং চাকরি",
      question: "আমি কি এই সার্টিফিকেট আমার ভিসা প্রসেসিং-এ ব্যবহার করতে পারব?",
      answer:
        "ভিসার নিয়মকানুন দেশভেদে ভিন্ন হয়। তবে অনেক রিক্রুটিং এজেন্সি বর্তমানে দক্ষতার প্রমাণ হিসেবে ManPowerX সার্টিফিকেটকে গুরুত্ব দেয়, যা আপনাকে ইন্টারভিউতে এগিয়ে রাখবে।",
    },

    // ৪. পেমেন্ট এবং টেকনিক্যাল সাপোর্ট
    {
      key: "9",
      category: "পেমেন্ট এবং টেকনিক্যাল সাপোর্ট",
      question: "আমি কোর্সের ফি কীভাবে পরিশোধ করব?",
      answer: (
        <>
          আপনি খুব সহজেই আপনার মোবাইল ফোন ব্যবহার করে পেমেন্ট করতে পারবেন। আমরা{" "}
          <strong className="text-theme-zinc-700">বিকাশ, নগদ, রকেট</strong> এবং
          যেকোনো বাংলাদেশি ডেবিট বা ক্রেডিট কার্ড সাপোর্ট করি।
        </>
      ),
    },
    {
      key: "10",
      category: "পেমেন্ট এবং টেকনিক্যাল সাপোর্ট",
      question: "আমি যদি পাসওয়ার্ড ভুলে যাই তবে কী করব?",
      answer: (
        <>
          লগইন স্ক্রিনে থাকা{" "}
          <span className="font-roboto">"Forgot Password"</span> লিঙ্কে ক্লিক
          করুন। আপনার রেজিস্টার্ড মোবাইল নম্বরে এসএমএস-এর মাধ্যমে একটি কোড
          পাঠানো হবে, যা দিয়ে আপনি নতুন পাসওয়ার্ড সেট করতে পারবেন।
        </>
      ),
    },
    {
      key: "11",
      category: "পেমেন্ট এবং টেকনিক্যাল সাপোর্ট",
      question: "ভিডিও লোড হচ্ছে না, এখন কী করব?",
      answer:
        "১. আপনার ইন্টারনেট কানেকশন চেক করুন। ২. অ্যাপের সেটিং থেকে ভিডিও কোয়ালিটি কমিয়ে দিন (যেমন: ৭২০পি থেকে ৩৬০পি)। ৩. অ্যাপটি একবার বন্ধ করে আবার চালু করুন অথবা ফোনের ক্যাশ (Cache) ক্লিয়ার করুন।",
    },

    // ৫. নিয়োগকর্তা এবং এজেন্সির জন্য
    {
      key: "12",
      category: "নিয়োগকর্তা এবং এজেন্সির জন্য",
      question: "আমরা কীভাবে ManPowerX থেকে দক্ষ কর্মী পেতে পারি?",
      answer: (
        <>
          আমাদের একটি আলাদা "পার্টনার পোর্টাল" আছে। এর মাধ্যমে এজেন্সিগুলো
          আমাদের সার্টিফাইড কর্মীদের ডাটাবেস দেখতে পারে এবং তাদের দক্ষতা যাচাই
          করতে পারে।
        </>
      ),
    },
  ];

  const customExpandIcon = ({ isActive }: any) =>
    isActive ? <CloseIcon /> : <PlusIcon />;

  return (
    <WebLayout>
      <CommonHeader
        title="Frequently Asked Questions"
        description="Last Updated: January 8, 2026"
      />

      <div className="mini-container md:!max-w-[1000px] pt-28 custom-faq">
        <Collapse
          accordion
          expandIconPosition="end"
          expandIcon={customExpandIcon}
          className="border-none"
          defaultActiveKey={["1"]}
          items={faqData.map((item) => ({
            key: item.key,
            label: (
              <Text className="text-theme-neutral-800 text-lg font-semibold">
                {item.question}
              </Text>
            ),
            children: (
              <Paragraph className="text-theme-slate-700 text-base font-normal">
                {item.answer}
              </Paragraph>
            ),
            className: "border-b border-gray-100 last:border-b-0",
          }))}
        />
      </div>

      <HelpInfo />

      <Platform />
      <Footer isPlatform />
    </WebLayout>
  );
}
